module.exports = __webpack_public_path__ + "static/tischler-logo-50-years-cc09916a3f813b557072bbbcaa86efb3.png";